// export const industryLeadersCard = [
//   {
//     tag: "1. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "Simple, straight to the point, with a lot of new features coming up. Great!",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "2. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     subTitle: "",
//     subDesc: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "3. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "4. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "5. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "6. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "7. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "8. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
// ];
export const industryLeadersCard = [
  {
    tag: "marketplace",
    logo: "greenleaf.png",
    quote:
      "Simple, straight to the point, with a lot of new features coming up. Great!",
    author: "Jonathan S.",
    authorTitle: "Marketing Manager",
  },
  {
    tag: "fintech",
    logo: "elemenopillows.png",
    quote:
      "BoloForms transformed document signing with a user-friendly interface, secure e-signatures, and seamless customization, streamlining our procedures.",
    author: "Juan Diego P.",
    authorTitle: "Operations Executive",
  },
  {
    tag: "marketplace",
    logo: "techsolutions.png",
    quote:
      "It's cheap and it just works! I had to do mass signatures of our team members and Boloforms made it easy for us to get signatures from our team faster.",
    author: "Sam K.",
    authorTitle: "Sales Lead",
  },
  {
    tag: "fintech",
    logo: "freshstart.png",
    quote: "Finally a simple to use yet full featured PDF signature app!",
    author: "Lisa Brown",
    authorTitle: "Owner",
  },
  {
    tag: "delivery",
    logo: "rappi.png",
    quote:
      "BoloForms made our document workflows seamless. The intuitive interface and reliable e-signatures significantly improved our team’s efficiency.",
    author: "Groham ",
    authorTitle: "Head of Product",
  },
];
